import {
    EvolutionDirection,
    ServiceScoreViewModel,
    ValueCode,
    ValueScoreViewModel,
    VALUE_CODES
} from "../models/OverviewDashboard";

export interface ServicePeriodStatistics {
    values: Record<ValueCode, ValueScoreViewModel>;
    averageScore?: number;
}

export const calculateAverageScore = (
    values: Record<ValueCode, ValueScoreViewModel>
): number | undefined => {
    const available = VALUE_CODES
        .map((code) => values[code].score)
        .filter((value): value is number => typeof value === "number" && Number.isFinite(value));

    if (available.length === 0) {
        return undefined;
    }

    return Math.round(
        (available.reduce((sum, value) => sum + value, 0) / available.length) * 10
    ) / 10;
};

export const compareServicePeriods = (
    current: ServicePeriodStatistics,
    previous: ServicePeriodStatistics
): Pick<ServiceScoreViewModel, "previousValues" | "previousAverageScore" | "evolution" | "evolutionDirection"> => {
    const currentAverage = current.averageScore;
    const previousAverage = previous.averageScore;

    if (currentAverage === undefined || previousAverage === undefined) {
        return {
            previousValues: previous.values,
            previousAverageScore: previousAverage,
            evolutionDirection: "no-data"
        };
    }

    const evolution = Math.round((currentAverage - previousAverage) * 10);

    return {
        previousValues: previous.values,
        previousAverageScore: previousAverage,
        evolution,
        evolutionDirection: getEvolutionDirection(evolution)
    };
};

const getEvolutionDirection = (evolution: number): EvolutionDirection => {
    if (evolution > 0) return "up";
    if (evolution < 0) return "down";
    return "stable";
};
